import * as React from 'react'

import { useTheme } from '../../../theme'
import { css } from 'glamor'

interface IImageRendererProps {
  alt?: string
  src?: string
}

export default function ImageRenderer({ alt, src }: IImageRendererProps) {
  const theme = useTheme()

  return (
    <img
      alt={alt}
      src={src}
      {...css({
        marginTop: theme.settings.spacing.large,
      })}
    />
  )
}
